import React from 'react';
import { Header } from 'semantic-ui-react';
import AmountTab from './tabs/amountTab';
import DetailsTab from './tabs/detailsTab';
import RecurringDetailsTab from './tabs/recurringDetailsTab';
import PaymentTab from './tabs/paymentTab';

const DonatePageView = props => {
    return (
        <div>
            <div className='page-view donate'>
                <div className="page-view-header">
                    <Header as="h2" className="page-view-heading">
                        1. Amount
			    	</Header>
                </div>
                <AmountTab />
                <div className="page-view-header">
                    <Header as="h2" className="page-view-heading">
                        2. Details
			    	</Header>
                </div>
                {
                    !props.isRecurring &&
                    <DetailsTab />
                }
                {
                    props.isRecurring &&
                    <RecurringDetailsTab />
                }
                <div className="page-view-header">
                    <Header as="h2" className="page-view-heading">
                        3. Payment
			    	</Header>
                </div>
                <PaymentTab />
            </div>
        </div>
    );
}

export default DonatePageView;